exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/ship-ref-status-tracking-widget/ship-ref-status-tracking-widget.css
// module id = ../../../../../src/app/shared/components/widget/ship-ref-status-tracking-widget/ship-ref-status-tracking-widget.css
// module chunks = main